import { useRouter } from "next/router";
import { useCallback } from "react";
export function useBuildId() {
  const {
    basePath
  } = useRouter();
  const shouldReload = useCallback(async () => {
    if (false) {
      return false;
    }
    try {
      var _JSON$parse;
      const buildId = (_JSON$parse = JSON.parse(document.querySelector("#__NEXT_DATA__").textContent)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.buildId;
      const res = await fetch(`${basePath}/api/buildid?id=${buildId}`).then(data => data.json());
      return !res.result;
    } catch (e) {
      console.log(e);
      return false;
    }
  }, []);
  return {
    shouldReload
  };
}